import { Col, ColProps, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

type PropsType = {
  data?: any[];
} & Omit<ColProps, "data">;

const NoDataRow = ({ data, ...props }: PropsType) => {
  const { t } = useTranslation(["translation"]);

  if (data?.length) return null;

  return (
    <Row>
      <Col {...props}>{t("translation:global.no_data")}</Col>
    </Row>
  );
};

export default NoDataRow;
